import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '1 — ¿Cómo recibo el material después de comprar?',
    a: '100% digital. Recibís el link de descarga por email en menos de 5 minutos. Funciona en celular, tablet o computadora. También podés imprimirlo.'
  }, {
    q: '2 — ¿Sirve para cualquier raza y tamaño de perro?',
    a: 'Sí. Los principios del protocolo son universales para cualquier raza y edad. Los tiempos varían pero el método funciona igual para un Bulldog Francés que para un Pastor Alemán.'
  }, {
    q: '3 — ¿Funciona si el perro ya es adulto?',
    a: 'Sí. Los adultos tardan un poco más en consolidar el aprendizaje pero responden igual de bien. No hay edad demasiado tarde para empezar.'
  }, {
    q: '4 — ¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en el Pack Esencial y en el Pack Completo. La diferencia es que el Pack Completo incluye además El Acelerador de Calma™.'
  }, {
    q: '5 — ¿Sirve si tengo un rescatado con trauma?',
    a: 'Sí, con tiempos más largos. El Módulo J del Tomo 3 y el Tomo 6 completo están dedicados a perros rescatados y con historia difícil.'
  }, {
    q: '6 — ¿Cuánto tiempo por día necesito?',
    a: 'Entre 15 y 30 minutos diarios. El protocolo está diseñado para la vida real de una persona que trabaja y tiene horarios irregulares.'
  }, {
    q: '7 — ¿Qué pasa si tengo un retroceso?',
    a: 'El Tomo 3 y el Módulo 5 del Acelerador están completamente dedicados a los retrocesos. Tenés un protocolo para recuperarte en 3-5 días sin empezar de cero.'
  }, {
    q: '8 — ¿Qué diferencia tiene con otros materiales del mercado?',
    a: 'La Guía Del Perro Tranquilo es el único sistema en español que combina diagnóstico, protocolo de 21 días, lectura de señales en tiempo real y auditoría semanal en un solo recurso. No es teoría: es implementación paso a paso.'
  }, {
    q: '9 — ¿Por qué elegir el Pack Completo con Acelerador?',
    a: 'Porque la brecha entre saber qué hacer y ejecutarlo bien es donde se pierde el 70% de los procesos. El Acelerador cierra esa brecha con criterios exactos para cada momento de los 21 días.'
  }, {
    q: '10 — ¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Menos del 1% de devoluciones. Escribís a soportemundorecursos@gmail.com y listo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-138">
      <div className="text-center mb-12" data-id="element-139">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white" data-id="element-140">
          PREGUNTAS FRECUENTES
        </motion.h2>
      </div>

      <div className="space-y-4" data-id="element-141">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.05
      }} className="border border-navy-600 bg-navy-800/50 rounded-2xl overflow-hidden" data-id="element-142">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-143">
              <span className="font-semibold text-white text-base md:text-lg pr-8" data-id="element-144">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-gold-400 transform transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-145" />
            </button>
            <AnimatePresence data-id="element-146">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-147">
                  <div className="px-6 pb-5 text-blue-100/80 leading-relaxed border-t border-navy-700/50 pt-4" data-id="element-148">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}